import { OrbConnectionManager } from "../connections/OrbConnectionManager";
import { DefaultEdgeProfile } from "../connections/edges/EdgeProfiles";
export function connectOrbs({ from, to, profile }) {
    var _a;
    const cm = OrbConnectionManager.getInstance();
    // De-dup
    if (cm.has(from, to))
        return;
    const merged = Object.assign(Object.assign(Object.assign({}, DefaultEdgeProfile), profile), { arrows: Object.assign({ start: false, end: true }, ((_a = profile === null || profile === void 0 ? void 0 : profile.arrows) !== null && _a !== void 0 ? _a : {})) });
    cm.connect({
        type: "edge",
        a: from,
        b: to,
        profile: merged,
    });
}
